import { SplitText } from '../globals/gsap';

class Intro {
  constructor($el) {
    this.$el = $el;

    this.init();
  }

  init = () => {
    this.splitText = new SplitText(this.$el, { type: 'words', wordsClass: 'word' });

    this.splitText.words.forEach((word,index) => {
      // add index to data-index attribute
      const $word = $(word);
      $word.attr('data-word', word.textContent);
      // add index as css variable
      $word.css('--index', index);
    });

    this.$el.addClass('initted');

    setTimeout(() => {
      this.$el.addClass('intro--fade-in');
    }, 250);


  }
}

export default Intro;